'use client'

import s from './page.module.scss';
import {Container} from "@/app/[locale]/common/components/Container/Container";
import {ContactUs} from "@/app/[locale]/common/components/ContactUs/ContactUs";
import {TIndustriesCardProps} from "@/app/[locale]/common/components/Industries/types";
import {IndustriesCard} from "@/app/[locale]/common/components/Industries/IndustriesCard";
import {Title} from "@/app/[locale]/common/components/Title/Title";
import {Breadcrumbs} from "@/app/[locale]/common/components/Breadcrumbs/Breadcrumbs";
import {useTranslations} from "next-intl";

export default function Industries() {
    const t = useTranslations('IndustriesPage');

    return (
        <section className={s.industries}>
            <Container>
                <Breadcrumbs crumb={[t.raw('breadcrumbs')]} />
                <Title title={t('title')} />
                <div className={s.industries_cardsContainer}>
                    {
                        t.raw('data').map((item: TIndustriesCardProps, index: number) => (
                            <IndustriesCard
                                key={index}
                                label={item.label}
                                text={item.text}
                                href={item.href}
                                image={item.image}
                            />
                        ))
                    }
                </div>
                <ContactUs/>
            </Container>
        </section>
    );
}